import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";


export function Equipment(props) {




    const equipment = useSelector((state) => state.equipment)

    const login = useSelector((state) => state.login)
    let navigate = useNavigate();
    useEffect(() => {
        if (!login.token) {
          return navigate("/login");
        }
      })
    //-----------------redirect------------------------

    //--------------------------------------
    return (
        <Stack gap={3} className="col-md-8 mx-auto">
            <>
                <Button variant="outline-dark" as={Link} to="/manual">
                    Выбрать в ручную </Button>
                <Button variant="outline-dark" as={Link} to="/scan" >
                    Выбрать по QR</Button>

            </>
        </Stack>
    );
}
